import { Controller } from "stimulus"
import { SaveAs } from 'file-saver'

export default class extends Controller {
  connect() {
    var dataContent = this.element.dataset.fileContent;
    var byteCharacters = atob(dataContent);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);

    var blob = new Blob([byteArray], { type: this.element.dataset.contentType });

    saveAs(blob, this.element.dataset.fileName);

    this.element.parentElement.src = null;
    this.element.remove();
  }
}